export default __webpack_public_path__ + "static/media/home.0d7ddc8d.svg";